// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6139) return "static/chunks/6139-4f30aa42ddbe6c03.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "207170342d17fc72" + ".js";
};